import { createContext, useMemo, useEffect } from 'react';
import { invert } from 'lodash';
import { useMultiLayerDrawerContext } from '../../taboola-common-frontend-modules/multi-layer-drawer/components/MultiLayerDrawerProvider/MultiLayerDrawerProvider';
import { useMultiLayerDrawerEnabled } from '../../taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';

export const ModuleContext = createContext({
    toGWTransformers: {},
    entities: {},
    entitiesToPath: {},
    pathToEntity: {},
});
const DEFAULT_TO_GW_TRANSFORMERS = {};
const DEFAULT_ENTITIES = {};
const DEFAULT_ENTITIES_TO_PATH = {};
export const ModuleProvider = ({
    children,
    toGWTransformers = DEFAULT_TO_GW_TRANSFORMERS,
    entities = DEFAULT_ENTITIES,
    entitiesToPath = DEFAULT_ENTITIES_TO_PATH,
    moduleName,
}) => {
    const value = useMemo(() => {
        const pathToEntity = invert(entitiesToPath);
        return { toGWTransformers, entities, entitiesToPath, pathToEntity };
    }, [toGWTransformers, entities, entitiesToPath]);

    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();
    const { moduleProviders, registerModuleProviders } = useMultiLayerDrawerContext();

    useEffect(() => {
        if (!isMultiLayerDrawerEnabled || !!moduleProviders[moduleName]) {
            return;
        }

        registerModuleProviders({
            moduleName,
            provider: ({ children }) => <ModuleContext.Provider value={value}>{children}</ModuleContext.Provider>,
        });
    }, [isMultiLayerDrawerEnabled, moduleProviders, registerModuleProviders, value, children, moduleName]);

    if (isMultiLayerDrawerEnabled) {
        return <>{children}</>;
    }

    return <ModuleContext.Provider value={value}>{children}</ModuleContext.Provider>;
};
